import React from 'react'
import { useState, useEffect } from 'react'
import PlayerSmallCard from '../components/PlayerSmallCard'

function PlayersPage() {
  const [playersList, setPlayersList] = useState([])
  const [input, setInput] = useState('')

  useEffect(() => {
    fetchPlayers('')
  }, [])

  const fetchPlayers = (input) => {
    let url
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '42b487df01msh9367a40af1580cap17dd76jsn8040671db253',
        'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com',
      },
    }
    {
      input === ''
        ? (url =
            'https://api-football-v1.p.rapidapi.com/v3/players/topscorers?league=2&season=2022')
        : (url = `https://api-football-v1.p.rapidapi.com/v3/players?league=2&season=2022&search=${input}`)
    }
    fetch(url, options)
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
        setPlayersList(response.response)
      })
      .catch((err) => console.error(err))
  }

  return (
    <section className='mt-28  mx-10 h-fuw-full  '>
      <div className='md:w-3/6  mx-auto'>
        <div className=''>
          <label
            for='default-search'
            class='mb-2 text-sm font-medium text-gray-900 sr-only '
          >
            Search
          </label>
          <div class='relative'>
            <div class='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
              <svg
                aria-hidden='true'
                class='w-5 h-5 text-gray-500'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  stroke-width='2'
                  d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                ></path>
              </svg>
            </div>
            <input
              onChange={(e) => {
                setInput(e.target.value)
              }}
              type='search'
              id='default-search'
              class='block w-full 
         p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-violet-500 dark:focus:border-violet-500'
              placeholder='Search player...'
            />
            <button
              className='"text-white absolute right-2.5 bottom-2.5 bg-violet-400 hover:bg-violet-600 focus:ring-4  focus:ring-violet-300 font-medium rounded-lg text-sm px-4 py-2'
              onClick={() => fetchPlayers(input)}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      <div className=' mt-11 w-full min-h-[80px] grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
        {playersList.map((item, index) => {
          if (index <= 25)
            return (
              <PlayerSmallCard
                key={item.player.id}
                name={item.player.name}
                imgPlayer={item.player.photo}
                imgTeam={item.statistics[0].team.logo}
                id={item.player.id}
              />
            )
        })}
      </div>
    </section>
  )
}

export default PlayersPage
